/**
 * Ordem alfabética de nome de gente, em português.
 *
 * Parece o tipo de coisa que o banco resolve com `ORDER BY name`, e não
 * resolve: a imagem do Postgres do projeto é a alpine, que roda em musl e não
 * tem locale de verdade. O banco se declara `en_US.utf8` e mesmo assim compara
 * byte a byte — maiúsculas primeiro, minúsculas depois, acentuadas no fim.
 * "Bruno, João, Zeca, ana paula, Álvaro" é uma ordenação legítima para o
 * Postgres e um embaralhamento para quem está com o celular na mão.
 *
 * Poderia ser resolvido prendendo uma colação ICU na coluna, e essa foi a
 * primeira tentativa. Duas coisas a derrubaram: o Prisma não modela colação
 * (ela não aparece no `schema.prisma`, some numa recriação de coluna e nada
 * acusa), e o banco de teste nasce de `prisma db push`, que ignora as
 * migrações — o teste passaria no ar e falharia na suíte. Aqui a regra é pura,
 * roda em milissegundos e vale igual nos dois lugares.
 */

/**
 * Um colator só para todos os usos: construir `Intl.Collator` é caro e
 * ordenar uma lista de clientes chama `compare` uma vez por comparação.
 */
const collator = new Intl.Collator('pt-BR');

/** Compara dois nomes como um leitor brasileiro esperaria vê-los na lista. */
export function compareNames(a: string, b: string): number {
  return collator.compare(a, b);
}

/**
 * Ordena por nome sem mexer no array recebido.
 *
 * `Array.prototype.sort` ordena no lugar, e o que chega aqui é o resultado de
 * uma consulta que outra parte do código pode estar lendo.
 */
export function sortByName<T>(items: readonly T[], nameOf: (item: T) => string): T[] {
  return [...items].sort((a, b) => compareNames(nameOf(a), nameOf(b)));
}
